import React from "react";
import {
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import CampaignManagementFilterForm from "./forms/CampaignManagementFilterForm";
import CampaignTable from "./CampaignManagement";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";
import { useNavigate } from "react-router-dom";

function CampaignWrapper() {
     const navigate = useNavigate();
    const handleCampaign = () =>{ 
        let path = `/app/incentive-data-manages/add`; 
        navigate(path);
      }
     return (
          <div className="sbt-data-grid__wr">
               <MainLeftTitle title="Incentive Management">
                    <CreateButton onClick={handleCampaign} name="Create Campaign" />
               </MainLeftTitle>
                    <UiAccordian>
                         <SearchBarWr>
                              <CampaignManagementFilterForm/>
                         </SearchBarWr>
                    </UiAccordian>
               <CampaignTable />
          </div>
     );
}

export default CampaignWrapper;
